import { render, staticRenderFns } from "./ButtonMini.vue?vue&type=template&id=0947f9e4&scoped=true&"
import script from "./ButtonMini.vue?vue&type=script&lang=js&"
export * from "./ButtonMini.vue?vue&type=script&lang=js&"
import style0 from "./ButtonMini.vue?vue&type=style&index=0&id=0947f9e4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947f9e4",
  null
  
)

export default component.exports